export * from './account.service';
import { AccountService } from './account.service';
export * from './backofficeAccount.service';
import { BackofficeAccountService } from './backofficeAccount.service';
export * from './backofficeBrands.service';
import { BackofficeBrandsService } from './backofficeBrands.service';
export * from './backofficeDocuments.service';
import { BackofficeDocumentsService } from './backofficeDocuments.service';
export * from './contacts.service';
import { ContactsService } from './contacts.service';
export * from './dictionary.service';
import { DictionaryService } from './dictionary.service';
export * from './file.service';
import { FileService } from './file.service';
export * from './goldfinger.service';
import { GoldfingerService } from './goldfinger.service';
export * from './mailing.service';
import { MailingService } from './mailing.service';
export * from './myLibrary.service';
import { MyLibraryService } from './myLibrary.service';
export * from './security.service';
import { SecurityService } from './security.service';
export const APIS = [AccountService, BackofficeAccountService, BackofficeBrandsService, BackofficeDocumentsService, ContactsService, DictionaryService, FileService, GoldfingerService, MailingService, MyLibraryService, SecurityService];
